import axios from 'axios';

// const isProd = 'REACT_APP_ENVIRONMENT' in process.env && process.env.REACT_APP_ENVIRONMENT === 'prod';
// const isTest = 'REACT_APP_ENVIRONMENT' in process.env && process.env.REACT_APP_ENVIRONMENT === 'test'
const isProd = window.location.hostname === 'falcon.arzoopro.com';
const isTest = window.location.hostname === 'falcon.dev.arzoopro.com';
let hostApi = '';
if (isProd) hostApi = 'https://gateway.arzoopro.com/v1/falcon/';
else if (isTest) hostApi = 'https://m.dev.arzoopro.com/';
else hostApi = 'https://m.dev.arzoopro.com/';

const instance = axios.create({
  baseURL: hostApi,
});

const refreshToken = async (token) => {
  let newRes = await instance.post(`user/seller/refresh_token`, {
    refreshToken: token.refreshToken,
  });
  let token_obj = {
    accessToken: newRes.data.accessToken,
    refreshToken: token.refreshToken,
  };

  localStorage.setItem('token', JSON.stringify(token_obj));
  return newRes;
};

const sessionExpired = () => {
  localStorage.clear();
  return (window.location.href = '/login');
};

const get = async (url, param, time) => {
  const axiosConfig = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  const token = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : {};
  axiosConfig.headers.Authorization = 'Bearer '.concat(token.accessToken);
  if (time) axiosConfig.timeout = time.timeout;
  if (param) axiosConfig.params = param.params;
  let res = await instance.get(url, axiosConfig);
  let respo;
  if (res.data.msg === 'Invalid Token') {
    return sessionExpired();
  }
  if (res.data.msg === 'Token Expired') {
    let newRes = await refreshToken(token);
    axiosConfig.headers.Authorization = 'Bearer '.concat(newRes.data.accessToken);
    let response = await instance.get(url, axiosConfig);

    if (response.data.msg === 'Invalid Token') {
      return sessionExpired();
    }

    respo = response;
  } else {
    respo = res;
  }
  return respo;
};

//// It is an axios delete wraper////
const remove = async (url, data) => {
  const axiosConfig = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  const token = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : {};
  axiosConfig.headers.Authorization = 'Bearer '.concat(token.accessToken);
  if (data) {
    axiosConfig.data = data;
  }
  let res = await instance.delete(url, axiosConfig);
  let respo;
  if (res.data.msg === 'Invalid Token') {
    return sessionExpired();
  }
  if (res.data.msg === 'Token Expired') {
    let newRes = await refreshToken(token);
    axiosConfig.headers.Authorization = 'Bearer '.concat(newRes.data.accessToken);
    let response = await instance.delete(url, axiosConfig);

    if (response.data.msg === 'Invalid Token') {
      return sessionExpired();
    }

    respo = response;
  } else {
    respo = res;
  }
  return respo;
};

const post = async (url, data, withCred) => {
  try {
    const axiosConfig = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    const token = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : {};
    axiosConfig.headers.Authorization = 'Bearer '.concat(token.accessToken);
    let res;
    let respo;
    if (withCred && !withCred.withCredentials) {
      if (withCred.headers) {
        if (withCred.headers['Content-Type'] === undefined) {
          axiosConfig.headers['Content-type'] = undefined;
        } else {
          axiosConfig.headers['Content-type'] = withCred.headers['Content-Type'];
        }
        res = await instance.post(url, data, axiosConfig);
      } else {
        res = await instance.post(url, data);
      }
      respo = res;
    } else {
      res = await instance.post(url, data, axiosConfig);
      if (res.data.msg === 'Invalid Token') {
        return sessionExpired();
      }
      if (res.data.msg === 'Token Expired') {
        let newRes = await refreshToken(token);

        axiosConfig.headers.Authorization = 'Bearer '.concat(newRes.data.accessToken);

        res = await instance.post(url, data, axiosConfig);
        if (res.data.msg === 'Invalid Token') {
          return sessionExpired();
        }
      }
      respo = res;
    }
    return respo;
  } catch (error) {
    console.error('❌ API POST Error:', {
      url,
      status: error?.response?.status,
      message: error?.message,
      data: error?.response?.data,
    });
    return error?.response;
  }
};

const postWithoutToken = async (url, data) => {
  const axiosConfig = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  const res = await instance.post(url, data, axiosConfig);

  return res;
};

const getWithoutToken = async (url, data) => {
  const axiosConfig = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  const res = await instance.get(url, axiosConfig);

  return res;
};

const put = async (url, data) => {
  const axiosConfig = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  const token = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : {};
  axiosConfig.headers.Authorization = 'Bearer '.concat(token.accessToken);
  let res = await instance.put(url, data, axiosConfig);
  if (res.data.msg === 'Invalid Token') {
    return sessionExpired();
  }
  if (res.data.msg === 'Token Expired') {
    let newRes = await refreshToken(token);

    axiosConfig.headers.Authorization = 'Bearer '.concat(newRes.data.accessToken);

    res = await instance.put(url, data, axiosConfig);
    if (res.data.msg === 'Invalid Token') {
      return sessionExpired();
    }
  }

  return res;
};

const API = { get, post, remove, put, postWithoutToken, getWithoutToken };

export default API;
